import Utils from '../../utils/Utils';

import UserStore from '../../stores/UserStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndpoints } from '../../constants/GuestListConstants';

import PageHeader from '../form/layout/PageHeader.react';

import GLTransactionsAdjustment from './GLTransactionsAdjustment.react';
import GLTransactionsCloseOut from './GLTransactionsCloseOut.react';
import GLTransactionsDetails from './GLTransactionsDetails.react';

class GLTransactions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            transactions : [],
            endingBalance : 0,
            startingBalance : 0,
            firstTransaction : 0,
            lastTransaction : 0,
            transactionCount : 0,
            transactionTotal: 0,
            newBalance: 0
        };

        this.loadTransactions = this.loadTransactions.bind(this);
        this.loadRegisterBalance = this.loadRegisterBalance.bind(this);
        this.setNewBalance = this.setNewBalance.bind(this);
    }

    componentDidMount() {
        this.loadTransactions();
        this.loadRegisterBalance();
    }

    loadTransactions() {
        AjaxPromises.POST(GuestListEndpoints.GET_REGISTER_TRANSACTIONS, UserStore.getApiData({
            fromDate : moment().format('MM/DD/YYYY'),
            toDate : moment().add(24, 'hours').format('MM/DD/YYYY'),
            RegisterId : this.props.selectedRegister.id
        })).then(res => {
            this.setState({
                transactions : res.Data
            });
        })
    }

    loadRegisterBalance() {
        AjaxPromises.POST(GuestListEndpoints.GET_CLOSEOUT_DETAILS, UserStore.getApiData({
            RegisterId : this.props.selectedRegister.id
        })).then(res => {
            if (res.Result) {
                if (res.Data && res.Data.length > 0) {
                    this.setState({ endingBalance : res.Data[0].endingBalance,
                        startingBalance : res.Data[0].startingBalance,
                        fristTransaction : res.Data[0].firstTransaction,
                        lastTransaction : res.Data[0].lastTransaction,
                        transactionTotal : res.Data[0].transactionTotal,
                        transactionCount: res.Data[0].transactionCount,
                        newBalance: res.Data[0].startingBalance
                     });
                }   
            }
        });
    }

    setNewBalance(newBalance) {
        this.setState({ newBalance });
    }

    render() {
        const { selectedRegister } = this.props;
        return ([
            <div className='gl-location'>
                <div className='gl-location__container'>
                    <div className='container'>

                        <PageHeader title={'Transactions for register '+selectedRegister.TerminalName} />

                        <div className='transactions'>
                            <table className='table-2'>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Action</th>
                                        <th>Date</th>
                                        <th>Start Balance</th>
                                        <th>Amount</th>
                                        <th>Ending Balance</th>
                                        <th>Due Customer</th>
                                        <th>Cashier</th>
                                        <th>Comments</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    { this.state.transactions.map(x => {
                                        return (
                                            <tr
                                                onClick={() => { this.setState({ selected : x }); }}
                                                key={x.id}>

                                                <td>{x.transactionID}</td>
                                                <td>{x.EntryType}</td>
                                                <td>{moment(x.TransactionDateTime).format('MM-DD-YYYY HH:mm a')}</td>
                                                <td className='text-right'>{Utils.formatAsPrice(x.StartBalance)}</td>
                                                <td className='text-right'>{Utils.formatAsPrice(x.EntryAmount)}</td>
                                                <td className='text-right'>{Utils.formatAsPrice(x.EndingBalance)}</td>
                                                <td className='text-right'>{Utils.formatAsPrice(x.TotalDueCustomer)}</td>
                                                <td>{x.TransactionBy}</td>
                                                <td>{x.Comments}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <PageHeader title='Close Out' />

                        <GLTransactionsCloseOut
                            selectedRegister={selectedRegister}
                            endingBalance={this.state.endingBalance}
                            newBalance={this.state.newBalance}
                            startingBalance={this.state.startingBalance}
                            transactionTotal={this.state.transactionTotal}
                            setNewBalance={this.setNewBalance}
                            onReload={() => {
                                this.loadTransactions();
                                this.loadRegisterBalance();
                            }} />

                        <PageHeader title='Make adjustment' />

                        <GLTransactionsAdjustment
                            selectedRegister={selectedRegister}
                            balance={this.state.endingBalance}
                            onReload={() => {
                                this.loadTransactions();
                                this.loadRegisterBalance();
                            }} />

                    </div>
                </div>
            </div>,

            ( this.state.selected &&
                <GLTransactionsDetails
                    transaction={this.state.selected}
                    onClose={() => { this.setState({ selected : false }) }} />
            )
        ]);
    }
}

export default GLTransactions;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLTransactions.react.jsx